import { useEffect, useState } from "react";
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import { useLoaderData, useParams } from "react-router-dom";
import { DocumentacionCreate, DocumentacionCreateWithFile } from "./DocumentacionCreate";
import { FileUploader } from "./FileUploader";

import { CertInfTratField } from "../components/documentacion/CertInfTrat";
import { ConInfAlcConSegField } from "../components/documentacion/ConInfAlcConSeg";
import { ConInfAlcSinSegField } from "../components/documentacion/ConInfAlcSinSeg";
import { ConInfBenzConSegField } from "../components/documentacion/ConInfBenzConSeg";
import { ConInfBenzSinSegField } from "../components/documentacion/ConInfBenzSinSeg";
import { ConInfCocConSegField } from "../components/documentacion/ConInfCocConSeg";
import { ConInfCocSinSegField } from "../components/documentacion/ConInfCocSinSeg";
import { ConInfHachConSegField } from "../components/documentacion/ConInfHachConSeg";
import { ConInfHachSinSegField } from "../components/documentacion/ConInfHachSinSeg";
import { ConInfHerConSegField } from "../components/documentacion/ConInfHerConSeg";
import { ConInfHerSinSegField } from "../components/documentacion/ConInfHerSinSeg";
import { ConInfMetConSegField } from "../components/documentacion/ConInfMetConSeg";
import { ConInfMetSinSegField } from "../components/documentacion/ConInfMetSinSeg";
import { FactTratField } from "../components/documentacion/FactTrat";
import { InfAltaField } from "../components/documentacion/InfAlta";
import { InfValPautDecField } from "../components/documentacion/InfValPautDec";
import { VolPetAnalField } from "../components/documentacion/VolPetAnal";
import { VolPetCovField } from "../components/documentacion/VolPetCov";
import { CuestSaludField } from "../components/documentacion/CuestSalud";
import { OtrosDocField } from "../components/documentacion/OtrosDoc";

import * as APIUSER from "../services/user";
import * as APIPACIENTES from "../services/pacientes";
import * as APITRATAMIENTOS from "../services/tratamientos";


export function DocumentacionNew(props) {
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [docTitulo, setDocTitulo] = useState('');
  const [docData, setDocData] = useState({});
  const [docFile, setDocFile] = useState('');
  const [docFileName, setDocFileName] = useState("Ningún archivo adjunto");

  const [especialistaData, setEspecialistaData] = useState(props.currentUser);
  const [pacienteData, setPacienteData] = useState({});
  const [tratamientoData, setTratamientoData] = useState({});


  const updateData = data => {
      setDocData(data)
  }
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  // Load Especialista and Pacieste Autfill Data
	useEffect(() => {
		const loadAutofillData = async () => {

			// // promise settles and return its result
			// const especialista = await APIUSER.getCurrentUser();

			// // After fetching data stored it in posts state.
			// setEspecialistaData(especialista);

      // promise settles and return its result
			const tratamiento = await APITRATAMIENTOS.getTratamientoById(tratamientoId);

			// After fetching data stored it in posts state.
			setTratamientoData(tratamiento);

      // promise settles and return its result
			const paciente = await APIPACIENTES.getPacienteByID(pacienteId);

			// After fetching data stored it in posts state.
			setPacienteData(paciente);

		}

		// Call the function
		loadAutofillData();
	}, []);

  // Set filename in the uploader
  function handleChange(event) {
    setDocFile(event.target.files[0]);
    setDocFileName(event.target.files[0].name);
  }

  const docFieldComponent = () => {
    switch (docTitulo) {
      case "CertInfTrat":
        return <CertInfTratField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData} autoTratamientoData={tratamientoData} />;
      case "ConInfAlcConSeg":
        return <ConInfAlcConSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfAlcSinSeg":
        return <ConInfAlcSinSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfBenzConSeg":
        return <ConInfBenzConSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfBenzSinSeg":
        return <ConInfBenzSinSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfCocConSeg":
        return <ConInfCocConSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfCocSinSeg":
        return <ConInfCocSinSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfHachConSeg":
        return <ConInfHachConSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfHachSinSeg":
        return <ConInfHachSinSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfHerConSeg":
        return <ConInfHerConSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfHerSinSeg":
        return <ConInfHerSinSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfMetConSeg":
        return <ConInfMetConSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "ConInfMetSinSeg":
        return <ConInfMetSinSegField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "FactTrat":
        return <FactTratField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData}/>;
      case "InfAlta":
        return <InfAltaField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData} autoTratamientoData={tratamientoData} />;
      case "InfValPautDec":
        return <InfValPautDecField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData} />;
      case "VolPetAnal":
        return <VolPetAnalField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData} />;
      case "VolPetCov":
        return <VolPetCovField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData} />;
      case "CuestSalud":
        return <CuestSaludField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData} />;  
      case "OtrosDoc":
        return <OtrosDocField updateData={updateData} autoEspecialistaData={especialistaData} autoPacienteData={pacienteData} />;    
        default:
        return "";
    }
  };

  const submitDocumentacion = async (e) => {
    e.preventDefault();
    setIsLoadingSave(true);
    if (docFile) {
    try {
      await FileUploader(
        docFile
      ).then(
        (val) => {
          let docFileUrl = val.source_url;
          try {
            DocumentacionCreate(
               docTitulo, docData, tratamientoId, pacienteId, docFileUrl
            ).then(
              (val) => {
                window.location.replace(
                  `../documentacion/${val.id}`
                );
                console.log(val);
              },
              (error) => {
                console.log(error);
              }
            );
          } catch (err) {
            console.log(err);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
    } else {
      try {
        await DocumentacionCreate(
           docTitulo, docData, tratamientoId, pacienteId
        ).then(
          (val) => {
            window.location.replace(
              `../documentacion/${val.id}`
            );
            console.log(val);
          },
          (error) => {
            console.log(error);
          }
        );
      } catch (err) {
        console.log(err);
      }
    }
    setIsLoadingSave(false);
  };

  return (
    <>
    <div id="content">
      <form id='formNewElement' onSubmit={submitDocumentacion}>

        <div className='field'>
              <label htmlFor='docTitulo'>Documentación</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='docTitulo'
                    name='docTitulo'
                    defaultValue=''
                    required
                    onChange={(e) => setDocTitulo(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='CertInfTrat'>Certificado Informe del Tratamiento</option>
                    <option value='ConInfAlcConSeg'>Consentimiento Informado Alcohol Con Seguimiento</option>
                    <option value='ConInfAlcSinSeg'>Consentimiento Informado Alcohol Sin Seguimiento</option>
                    <option value='ConInfBenzConSeg'>Consentimiento Informado Benzodiacepinas Con Seguimiento</option>
                    <option value='ConInfBenzSinSeg'>Consentimiento Informado Benzodiacepinas Sin Seguimiento</option>
                    <option value='ConInfCocConSeg'>Consentimiento Informado Cocaina Con Seguimiento</option>
                    <option value='ConInfCocSinSeg'>Consentimiento Informado Cocaina Sin Seguimiento</option>
                    <option value='ConInfHachConSeg'>Consentimiento Informado Hachis Con Seguimiento</option>
                    <option value='ConInfHachSinSeg'>Consentimiento Informado Hachis Sin Seguimiento</option>
                    {/* <option value='ConInfHerConSeg'>Consentimiento Informado Heroina Con Seguimiento</option> */}
                    {/* <option value='ConInfHerSinSeg'>Consentimiento Informado Heroina Sin Seguimiento</option> */}
                    {/* <option value='ConInfMetConSeg'>Consentimiento Informado Metadona Con Seguimiento</option> */}
                    {/* <option value='ConInfMetSinSeg'>Consentimiento Informado Metadona Sin Seguimiento</option> */}
                    <option value='FactTrat'>Factura Tratamiento</option>
                    <option value='InfAlta'>Informe de Alta</option>
                    <option value='InfValPautDec'>Informe Valoracion con Pauta Decalaje</option>
                    <option value='VolPetAnal'>Volante Peticion Analitica</option>
                    <option value='VolPetCov'>Volante Test COVID</option>
                    <option value='CuestSalud'>Cuestionario de Salud</option>
                    <option value='OtrosDoc'>Otros Documentos</option>
                  </select>
                </div>
              </div>
            </div>
        <div className="pdf-dowload">
        {(docTitulo.length !== 0) &&
          <>
          {docFieldComponent()}
          </>
        }
        {/* {docTitulo.length && */}
        </div>
        {(docTitulo.length !== 0) &&
        <div className="pdf-upload">
          <h3>Documento firmado</h3>
          <div className="field file has-name">
            <label className="file-label">
              <input
              className="file-input"
              type="file" 
              name="docFile"
              onChange={handleChange}
              accept=".docx,.doc,.pdf" // Limitar la selección a .docx, .doc y .pdf
              />
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-upload"></i>
                </span>
                <span className="file-label">
                  Seleccionar archivo…
                </span>
              </span>
              <span className="file-name">
              {docFileName}
              </span>
            </label>
          </div>
        </div>
        }

      </form>
    </div>
    <div id='actions'>
        <button 
        className={`button is-link ${isLoadingSave ? 'is-loading' : ''}`} 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>

    </>

  );
}
